var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallArrow = function SvgSmallArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D252D",
    d: "M3.88.293.296 3.879c-.63.63-.184 1.707.707 1.707h7.172c.89 0 1.337-1.077.707-1.707L5.295.293a1 1 0 0 0-1.414 0"
  })));
};
export default SvgSmallArrow;